import { useState } from 'react'
import { StyledHeader, HeaderContainer, LogoContainer, Logo } from './styled'
import { Share } from './share'

export const Header = () => {
  const [isShareOpen, setIsShareOpen] = useState(false)
  const toggleShare = () => setIsShareOpen((v) => !v)

  return (
    <>
      <StyledHeader>
        <HeaderContainer>
          <div className="header-background"></div>
          <LogoContainer href="/">
            <Logo />
          </LogoContainer>
          <div>
            <Share isOpen={isShareOpen} onToggle={toggleShare} />
          </div>
        </HeaderContainer>
      </StyledHeader>
    </>
  )
}
